(function () {
  'use strict';

  const CONFIG = {
    qty: parseInt(document.getElementById('bp-root')?.dataset.qty || '6'),
    price: document.getElementById('bp-root')?.dataset.price || '349,00',
    currency: document.getElementById('bp-root')?.dataset.currency || 'R$',
    bundleVariantId: document.getElementById('bp-root')?.dataset.variantId || '',
    bundleHandle: document.getElementById('bp-root')?.dataset.bundleHandle || 'kit-6-por-r-349',
    countdownMinutes: parseInt(document.getElementById('bp-root')?.dataset.countdownMin || '360', 10),
    // identifica qual landing gerou o pedido (ver properties._landing no checkout)
    landingId: document.getElementById('bp-root')?.dataset.landingId || '',
    // Recursos ligados por landing. Sem os atributos, tudo se comporta como antes —
    // é o que mantém as landings de R$349 e R$399 intocadas.
    allowPartial: document.getElementById('bp-root')?.dataset.allowPartial === 'true',
    showPrices:   document.getElementById('bp-root')?.dataset.showPrices === 'true',
    // 'kit' = produto de preco fechado (padrao). 'ofertas' = produtos reais no
    // carrinho da loja, com os descontos automaticos (leve 2 pague 1 ... 8/4).
    modo: document.getElementById('bp-root')?.dataset.modo || 'kit',
    // Espelha cada pulseira escolhida no carrinho real da loja. Serve so para
    // MEDICAO: assim o pixel conta 1 "adicionar ao carrinho" por pulseira, com o
    // produto e o preco de verdade, em vez de um unico evento do kit no final.
    // O kit continua sendo o que vai para o checkout (o carrinho e limpo antes).
    trackItens: document.getElementById('bp-root')?.dataset.trackItens === 'true',
    // Abre a gaveta do tema a cada item adicionado, como no resto da loja.
    // Sem o atributo, segue o comportamento antigo (so a barra de baixo).
    abrirGaveta: document.getElementById('bp-root')?.dataset.abrirGaveta === 'true',
    // Lista fixa de produtos (handles separados por virgula). Quando existe, o grid
    // mostra SO esses, na ordem escrita, sem o ranking de mais vendidos. Serve para
    // landing de uma linha so (ex.: as 10 Wave). Sem o atributo, nada muda.
    handles: (document.getElementById('bp-root')?.dataset.handles || '')
      .split(',').map(h => h.trim()).filter(Boolean),
    // Mapa handle -> URL de video. Onde houver video, o card mostra o video no lugar
    // do carrossel de fotos. O modal de detalhes segue com as fotos.
    videos: (() => {
      try { return JSON.parse(document.getElementById('bp-root')?.dataset.videos || '{}'); }
      catch (e) { console.warn('[Beroc Bundle] data-videos invalido:', e); return {}; }
    })(),
  };

  // no modo ofertas nao existe teto de 6: o cliente leva quantas quiser
  if (CONFIG.modo === 'ofertas') CONFIG.qty = 999;

  const FAIXAS = [
    { itens: 2, nome: 'LEVE 2 PAGUE 1', gratis: 1 },
    { itens: 4, nome: 'LEVE 4 PAGUE 2', gratis: 2 },
    { itens: 6, nome: 'LEVE 6 PAGUE 3', gratis: 3 },
    { itens: 8, nome: 'LEVE 8 PAGUE 4', gratis: 4 },
  ];
  let carrinho = null;

  // Protecao de Envio (produto real da loja, R$ 9,90). Esta landing vai direto
  // para /checkout, entao o cliente nunca passa pelo carrinho — que e onde o
  // app oferece a protecao. As properties sao as mesmas que o app grava, para
  // o relatorio de anexo continuar batendo.
  const PROTECAO_VARIANT_ID = '46682765295859';
  const ehProtecao = item => String(item.variant_id) === PROTECAO_VARIANT_ID;
  // A protecao nao e pulseira: fica fora da contagem das faixas, senao ela
  // empurraria sozinha o progresso do "leve 2 pague 1".
  const totalPulseiras = c => (c && c.items ? c.items : [])
    .filter(i => !ehProtecao(i))
    .reduce((t, i) => t + i.quantity, 0);
  const linhaProtecao = c => {
    const idx = (c && c.items ? c.items : []).findIndex(ehProtecao);
    return idx === -1 ? 0 : idx + 1;   // /cart/change.js conta a partir de 1
  };

  const fmtBRL = n => n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const somaSelecionados = () => selected.reduce((t, i) => t + (Number(i.price) || 0), 0);
  // CONFIG.price vem formatado em pt-BR ("399,00"); vira número para as contas
  const precoBundle = () => Number(String(CONFIG.price).replace(/\./g, '').replace(',', '.')) || 0;

  let selected = [];

  function initCountdown() {
    const el = document.getElementById('bp-countdown');
    if (!el) return;
    const SESSION_KEY = 'bp_countdown_end';
    const DURACAO = CONFIG.countdownMinutes * 60 * 1000;

    function novoPrazo() {
      const end = Date.now() + DURACAO;
      sessionStorage.setItem(SESSION_KEY, String(end));
      return end;
    }

    // Recomeça se não houver prazo, se o valor estiver corrompido ou se já venceu.
    // Antes o timer travava em 00H 00M 00S pelo resto da sessão quando expirava.
    let end = parseInt(sessionStorage.getItem(SESSION_KEY), 10);
    if (!Number.isFinite(end) || end <= Date.now()) end = novoPrazo();

    function tick() {
      let diff = end - Date.now();
      if (diff <= 0) { end = novoPrazo(); diff = end - Date.now(); }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      el.textContent = `${String(h).padStart(2,'0')}H ${String(m).padStart(2,'0')}M ${String(s).padStart(2,'0')}S`;
      setTimeout(tick, 1000);
    }
    tick();
  }

  function initFilters() {
    const tipoBtns = document.querySelectorAll('[data-filter-tipo]');
    const materialBtns = document.querySelectorAll('[data-filter-material]');
    let activeTipo = 'all';
    let activeMaterial = 'all';
    function applyFilter() {
      document.querySelectorAll('.bp-product-card').forEach(card => {
        const tipo = card.dataset.tipo || 'pulseira';
        const material = card.dataset.material || 'metal';
        const tipoOk = activeTipo === 'all' || tipo === activeTipo;
        const materialOk = activeMaterial === 'all' || material === activeMaterial;
        card.style.display = (tipoOk && materialOk) ? '' : 'none';
      });
    }
    tipoBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        tipoBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        activeTipo = btn.dataset.filterTipo;
        applyFilter();
      });
    });
    materialBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        materialBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        activeMaterial = btn.dataset.filterMaterial;
        applyFilter();
      });
    });
  }

  // ---- modo OFERTAS: o carrinho da Shopify e a fonte da verdade ----
  // O desconto depende de QUAIS pulseiras foram escolhidas (as mais baratas
  // saem de graca), entao calcular o total no navegador daria numero errado.
  // Aqui a gente le o /cart.js e mostra exatamente o que o caixa vai cobrar.
  // Tira do carrinho a protecao que o cliente nao pediu. Sem rede quando nao ha
  // nada a fazer: so age se a linha existir e a escolha nao tiver sido feita.
  async function lerCarrinho() {
    // Em falha (rede, limite de requisicoes, resposta HTML) MANTEM o estado
    // anterior. Zerar aqui faria a barra dizer "nenhuma pulseira" com o
    // carrinho cheio — o cliente acharia que perdeu a selecao.
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (r.ok) {
        const txt = await r.text();
        if (txt.trim().charAt(0) === '{') carrinho = JSON.parse(txt);
        else console.warn('[Beroc] /cart.js nao devolveu JSON; mantendo estado anterior');
      }
    } catch (e) {
      console.warn('[Beroc] falha ao ler o carrinho, mantendo estado anterior:', e);
    }
    updateUI();
  }

  // Avisa o tema que o carrinho mudou. Sem isso o cart drawer continua
  // mostrando "seu carrinho esta vazio", porque ele foi renderizado no
  // carregamento e nao enxerga o que a gente adiciona por fetch.
  // 'cart:refresh' e o evento que o Prestige escuta (testado nesta loja).
  // Nao abre o drawer — so atualiza o conteudo e o pontinho do header.
  function avisarTema() {
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
    } catch (e) { /* tema sem esse evento: a barra continua funcionando */ }
  }

  async function addAoCarrinhoReal(variantId) {
    if (!variantId) return false;
    const linha = { id: parseInt(variantId, 10), quantity: 1 };
    if (CONFIG.landingId) linha.properties = { _landing: CONFIG.landingId };
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [linha] })
      });
      if (!r.ok) throw new Error('HTTP ' + r.status);
    } catch (e) {
      console.error('[Beroc] nao consegui adicionar ao carrinho:', e);
      shakeBar();
      return false;
    }
    await lerCarrinho();
    avisarTema();
    // a gaveta precisa do refresh do tema antes de aparecer, senao mostra o estado antigo
    if (CONFIG.abrirGaveta) setTimeout(abrirGaveta, 180);
    return true;
  }

  async function mudarLinhaCarrinho(linha, quantidade) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: linha, quantity: quantidade })
      });
    } catch (e) { console.error('[Beroc] falha ao mudar o carrinho:', e); }
    await lerCarrinho();
    avisarTema();
  }

  // Fila de chamadas ao carrinho: cliques rapidos em sequencia derrubam a API
  // da Shopify (429). Uma de cada vez, sem travar a interface.
  let filaCarrinho = Promise.resolve();
  function espelharNoCarrinho(variantId, novaQuantidade) {
    if (!CONFIG.trackItens || !variantId) return;
    filaCarrinho = filaCarrinho.then(() => {
      const url  = novaQuantidade === null ? '/cart/add.js' : '/cart/change.js';
      const body = novaQuantidade === null
        ? { id: parseInt(variantId), quantity: 1 }
        : { id: String(variantId), quantity: novaQuantidade };
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).catch(e => console.warn('[Beroc] espelho do carrinho falhou:', e));
    }).catch(() => {});
  }

  function addItem(item) {
    if (CONFIG.modo === 'ofertas') { addAoCarrinhoReal(item.variantId); return true; }
    if (selected.length >= CONFIG.qty) return false;
    selected.push(item);
    espelharNoCarrinho(item.variantId, null);
    updateUI();
    return true;
  }

  // Remove só a unidade daquele slot — a mesma variante pode estar repetida
  function removeAt(index) {
    if (index < 0 || index >= selected.length) return;
    const removido = selected[index];
    selected.splice(index, 1);
    if (removido) espelharNoCarrinho(removido.variantId, countOf(removido.variantId));
    updateUI();
  }

  function countOf(variantId) {
    if (!variantId) return 0;
    return selected.filter(i => i.variantId === variantId).length;
  }

  // A barra fixa cobre o fim da página. Publica a altura real dela em --bp-bar-h
  // para a última seção reservar exatamente esse espaço. A altura muda entre
  // desktop/mobile e conforme o texto do botão, por isso é medida e não fixa.
  function syncBarSpacing() {
    const bar = document.querySelector('.bp-sticky-bar');
    const root = document.getElementById('bp-root');
    if (!bar || !root) return;
    root.style.setProperty('--bp-bar-h', bar.offsetHeight + 'px');
  }

  function renderBarraOfertas() {
    const c = carrinho;
    const total = totalPulseiras(c);
    const q = s => document.querySelector(s);
    const fx = q('.bp-of__faixa'), dica = q('.bp-of__dica'), fill = q('.bp-of__fill');
    const preco = q('.bp-of__preco'), btn = q('.bp-checkout-btn'), minis = q('.bp-of__miniaturas');

    const atual = [...FAIXAS].reverse().find(f => total >= f.itens);
    const prox  = FAIXAS.find(f => total < f.itens);

    if (fx) {
      fx.textContent = atual
        ? `${atual.gratis} ${atual.gratis === 1 ? 'PEÇA GRÁTIS' : 'PEÇAS GRÁTIS'}`
        : 'NENHUMA GRÁTIS AINDA';
    }
    if (dica) {
      // sempre em cima do que o cliente GANHA, nao do nome da faixa
      if (total === 0) {
        dica.textContent = 'leve 2 e a segunda sai grátis';
      } else if (prox) {
        const faltam = prox.itens - total;
        const p = faltam === 1 ? 'Falta 1' : `Faltam ${faltam}`;
        const g = prox.gratis === 1 ? '1 grátis' : `${prox.gratis} grátis`;
        dica.textContent = `${p} para ${g}`;
      } else {
        dica.textContent = 'você já leva 4 grátis';
      }
    }
    if (fill) fill.style.width = Math.min(100, (total / 8) * 100) + '%';

    document.querySelectorAll('.bp-of__marco').forEach(m => {
      m.classList.toggle('ativo', total >= parseInt(m.dataset.marco, 10));
    });

    // miniaturas. A Shopify libera as MAIS BARATAS, entao marcamos essas.
    if (minis) {
      if (!c || total === 0) {
        minis.innerHTML = '<span class="bp-of__vazio">Escolha suas pulseiras abaixo</span>';
      } else {
        const unidades = [];
        c.items.forEach((i, idx) => {
          if (ehProtecao(i)) return;
          // linha e quantidade vao junto: sao o que o ✕ precisa para tirar
          // uma unidade sem mexer no resto da linha
          for (let k = 0; k < i.quantity; k++) {
            unidades.push({ img: i.image, nome: i.title || '', preco: i.price, linha: idx + 1, qtd: i.quantity });
          }
        });
        const qtdGratis = Math.floor(Math.min(total, 8) / 2);
        const indicesGratis = new Set(
          unidades.map((u, i) => i)
                  .sort((a, b) => unidades[a].preco - unidades[b].preco)
                  .slice(0, qtdGratis)
        );
        const thumb = url => url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        // Mostra as 8 da escada. Quando nao cabem na linha, a fila rola de lado
        // (CSS) — assim o cliente sempre alcanca qualquer pulseira para tirar.
        // So acima de 8 aparece o "+N", que abre a gaveta do carrinho.
        const MAX_MINIS = 8;
        let html = unidades.slice(0, MAX_MINIS).map((u, i) => {
          const free = indicesGratis.has(i);
          const alt = esc(u.nome);
          return '<div class="bp-of__mini' + (free ? ' bp-of__mini--gratis' : '') + '">'
            + '<img src="' + thumb(u.img) + '" alt="' + alt + '" loading="lazy">'
            + '<button type="button" class="bp-of__mini-x" data-linha="' + u.linha + '" data-qtd="' + u.qtd + '"'
            + ' aria-label="Remover ' + alt + '" title="Remover">✕</button>'
            + (free ? '<span class="bp-of__mini-tag">GRÁTIS</span>' : '')
            + '</div>';
        }).join('');
        if (total > MAX_MINIS) {
          html += '<button type="button" class="bp-of__mini bp-of__mini--mais" data-abrir-carrinho'
            + ' aria-label="Ver todas as ' + total + ' pulseiras no carrinho" title="Ver todas no carrinho">'
            + '<span>+' + (total - MAX_MINIS) + '</span></button>';
        }
        minis.innerHTML = html;
        // sombra na borda direita quando a fila rola: sem ela ninguem descobre
        // que existe pulseira fora da vista. Medido no frame seguinte, senao a
        // largura ainda e a de antes do preco entrar na linha.
        requestAnimationFrame(() => {
          minis.classList.toggle('rolando', minis.scrollWidth > minis.clientWidth + 2);
        });
      }
    }

    if (preco) {
      if (!c || total === 0) preco.innerHTML = '';
      else {
        const agora = (c.total_price / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        const antes = (c.original_total_price / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        preco.innerHTML = c.total_discount > 0
          ? `<small>${CONFIG.currency} ${antes}</small>${CONFIG.currency} ${agora}`
          : `${CONFIG.currency} ${agora}`;
      }
    }

    if (btn) {
      if (total > 0) { btn.classList.add('ready'); btn.disabled = false; btn.textContent = 'Finalizar compra →'; }
      else { btn.classList.remove('ready'); btn.disabled = true; btn.textContent = 'Escolha suas pulseiras'; }
    }

    const porVariante = {};
    if (c) c.items.forEach(i => { porVariante[String(i.variant_id)] = (porVariante[String(i.variant_id)] || 0) + i.quantity; });
    document.querySelectorAll('.bp-product-card').forEach(card => {
      const ids = (card.dataset.variantIds || '').split(',').filter(Boolean);
      const n = ids.reduce((t, id) => t + (porVariante[id] || 0), 0);
      card.classList.toggle('selected', n > 0);
      card.querySelectorAll('.bp-product-card__add').forEach(b => {
        b.textContent = n > 0 ? `Adicionar mais (${n})` : (b.dataset.label || 'Adicionar');
        b.classList.toggle('selected-variant', n > 0);
      });
    });
    syncBarSpacing();
  }

  function updateUI() {
    if (CONFIG.modo === 'ofertas') { renderBarraOfertas(); return; }
    const count = selected.length;
    const total = CONFIG.qty;
    const bar = document.querySelector('.bp-progress-bar__fill');
    if (bar) bar.style.width = `${(count / total) * 100}%`;
    const label = document.querySelector('.bp-sticky-bar__label');
    if (label && !CONFIG.allowPartial) {
      label.textContent = `Seu Bundle: ${count} de ${total} selecionadas`;
    } else if (label) {
      // Landing aberta: além da contagem, explica em texto o próximo passo.
      // A mensagem muda de tom conforme completar 6 economiza ou não — com 1 ou 2
      // pulseiras o avulso ainda sai mais barato que o kit, e dizer "economize"
      // ali seria mentira.
      const soma = somaSelecionados();
      const falta = total - count;
      let dica = '';
      if (count === 0) {
        dica = `Monte seu kit — ${total} por ${CONFIG.currency} ${CONFIG.price}`;
      } else if (count === total) {
        const economia = soma - precoBundle();
        dica = economia > 0
          ? `Preço de kit aplicado — você economizou ${CONFIG.currency} ${fmtBRL(economia)}`
          : `Preço de kit aplicado`;
      } else {
        const dif = soma - precoBundle();
        const verbo = falta === 1 ? 'Falta' : 'Faltam';
        dica = dif > 0
          ? `${verbo} ${falta} e você economiza ${CONFIG.currency} ${fmtBRL(dif)}`
          : `Por ${CONFIG.currency} ${fmtBRL(Math.abs(dif))} a mais, leve mais ${falta}`;
      }
      label.innerHTML = `<span class="bp-sticky-bar__count">${count} de ${total} selecionadas</span>`
        + `<span class="bp-sticky-bar__hint">${dica}</span>`;
    }
    const slots = document.querySelectorAll('.bp-slot');
    slots.forEach((slot, i) => {
      const item = selected[i];
      if (item) {
        slot.classList.add('filled');
        slot.innerHTML = `<img src="${item.image}" alt="${item.name}"><span class="bp-slot__remove">✕</span>`;
        slot.onclick = () => removeAt(i);
      } else {
        slot.classList.remove('filled');
        slot.innerHTML = `<span>${i + 1}</span>`;
        slot.onclick = null;
      }
    });
    const btn = document.querySelector('.bp-checkout-btn');
    const precoEl = document.querySelector('.bp-sticky-bar__price');
    if (btn) {
      if (count === total) {
        btn.classList.add('ready');
        btn.textContent = `Finalizar — ${CONFIG.currency} ${CONFIG.price}`;
        btn.disabled = false;
      } else if (CONFIG.allowPartial && count > 0) {
        // pode fechar com menos de 6, pagando o avulso
        btn.classList.add('ready');
        btn.textContent = `Finalizar — ${CONFIG.currency} ${fmtBRL(somaSelecionados())}`;
        btn.disabled = false;
      } else {
        btn.classList.remove('ready');
        btn.textContent = CONFIG.allowPartial ? 'Escolha suas pulseiras' : `Escolha ${total - count} mais`;
        btn.disabled = true;
      }
    }
    if (precoEl && CONFIG.allowPartial) {
      if (count === total) {
        precoEl.innerHTML = `<span class="bp-sticky-bar__now">${CONFIG.currency} ${CONFIG.price}</span>`;
      } else if (count > 0) {
        // mostra o que ele paga agora e para onde o preço vai ao completar o kit
        precoEl.innerHTML = `<span class="bp-sticky-bar__now">${CONFIG.currency} ${fmtBRL(somaSelecionados())}</span>`
          + `<span class="bp-sticky-bar__target">com ${total}: ${CONFIG.currency} ${CONFIG.price}</span>`;
      } else {
        precoEl.innerHTML = `<span class="bp-sticky-bar__now">${CONFIG.currency} ${CONFIG.price}</span>`
          + `<span class="bp-sticky-bar__target">levando ${total}</span>`;
      }
    }
    document.querySelectorAll('.bp-product-card').forEach(card => {
      const addBtns = card.querySelectorAll('.bp-product-card__add');
      let cardSelected = false;
      const idsDoCard = (card.dataset.variantIds || card.dataset.variantId || '').split(',').filter(Boolean);
      addBtns.forEach(btn => {
        // conta por produto, somando todas as variantes dele que estão no bundle
        const n = btn.dataset.variantId
          ? countOf(btn.dataset.variantId)
          : selected.filter(i => idsDoCard.includes(String(i.variantId))).length;
        if (n > 0) {
          cardSelected = true;
          btn.textContent = `Adicionar mais (${n})`;
          btn.classList.add('selected-variant');
        } else {
          btn.textContent = btn.dataset.label || 'Adicionar';
          btn.classList.remove('selected-variant');
        }
      });
      card.classList.toggle('selected', cardSelected);
    });
    syncBarSpacing();
  }

  function buildVariantPicker(card, variants, onSelect) {
    const existing = card.querySelector('.bp-variant-picker');
    if (existing) { existing.remove(); return; }
    // esgotadas não entram na lista de opções
    variants = (variants || []).filter(v => v.available);
    if (!variants.length) return;
    const picker = document.createElement('div');
    picker.className = 'bp-variant-picker';
    picker.innerHTML = `
      <div class="bp-variant-picker__label">Escolha uma opção:</div>
      <div class="bp-variant-picker__options"></div>
      <button class="bp-variant-picker__close">✕</button>
    `;
    const optionsEl = picker.querySelector('.bp-variant-picker__options');
    variants.forEach(v => {
      const btn = document.createElement('button');
      btn.className = 'bp-variant-option';
      btn.textContent = v.title;
      btn.addEventListener('click', () => {
        if (selected.length >= CONFIG.qty) { shakeBar(); picker.remove(); return; }
        const rawImg = v.featured_image?.src || '';
        onSelect({
          variantId: String(v.id),
          name: `${card.dataset.name} — ${v.title}`,
          image: rawImg.startsWith('//') ? 'https:' + rawImg : (rawImg || card.dataset.image),
          tipo: card.dataset.tipo,
          material: card.dataset.material,
          price: v.price,
        });
        picker.remove();
      });
      optionsEl.appendChild(btn);
    });
    picker.querySelector('.bp-variant-picker__close').addEventListener('click', () => picker.remove());
    card.appendChild(picker);
  }

  // Converte URL relativa de protocolo (//cdn...) para https://cdn...
  function imgUrl(raw) {
    if (!raw) return '';
    const url = typeof raw === 'string' ? raw : (raw.src || '');
    return url.startsWith('//') ? 'https:' + url : url;
  }

  async function fetchProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('Produto não encontrado');
      return await res.json();
    } catch (e) {
      console.error('[Beroc Bundle] fetchProduct error:', e);
      return null;
    }
  }

  function initCard(card) {
    const addBtn = card.querySelector('.bp-product-card__add');
    if (addBtn) {
      addBtn.dataset.label = 'Adicionar';
      addBtn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const handle = card.dataset.handle;
        const variantCount = parseInt(card.dataset.variantCount || '1');
        const singleVariantId = card.dataset.variantId;
        if (variantCount === 1) {
          if (selected.length >= CONFIG.qty) { shakeBar(); return; }
          addItem({
            variantId: singleVariantId,
            name: card.dataset.name,
            image: card.dataset.image,
            tipo: card.dataset.tipo,
            material: card.dataset.material,
            price: card.dataset.price,
          });
          return;
        }
        if (selected.length >= CONFIG.qty) { shakeBar(); return; }
        const product = await fetchProduct(handle);
        if (!product) return;
        buildVariantPicker(card, product.variants, addItem);
      });
    }
    async function abrirDetalhes(e) {
      if (e) e.stopPropagation();
      const handle = card.dataset.handle;
      const product = await fetchProduct(handle);
      if (product) {
        openQuickView(product, card);
      } else {
        openQuickViewBasic({
          variantId: card.dataset.variantId,
          name: card.dataset.name,
          image: card.dataset.image,
          description: card.dataset.description || '',
        });
      }
    }

    const qvBtn = card.querySelector('.bp-product-card__quick');
    if (qvBtn) qvBtn.addEventListener('click', abrirDetalhes);

    // Clicar na própria foto abre os mesmos detalhes do botão "Ver Detalhes".
    // Um arrasto não dispara isso: o handler de swipe engole o clique final.
    const imgBox = card.querySelector('.bp-product-card__img');
    if (imgBox) imgBox.addEventListener('click', abrirDetalhes);
  }

  function initCards() {
    document.querySelectorAll('.bp-product-card').forEach(initCard);
  }

  // Fora do grid das landings de bundle. 'Veleiro' excluido a pedido em 20/08/2026.
  // É esta lista que manda no grid, não a coleção bundle-pulseiras — ela não é usada.
  const EXCLUDED_KEYWORDS = ['Kit ', 'Embalagem', 'Fecho', 'Gravação', 'Personalizada', 'Veleiro'];

  function esc(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function detectTipoMaterial(title) {
    const tipo = title.includes('Colar') ? 'colar' : 'pulseira';
    let material = 'metal';
    if (title.includes('Corda')) material = 'corda';
    else if (title.includes('Couro')) material = 'couro';
    else if (title.includes('Pedra')) material = 'pedra';
    return { tipo, material };
  }

  function initCardCarousel(card, imageCount) {
    if (imageCount <= 1) return;
    const imgContainer = card.querySelector('.bp-product-card__img');
    const imgs = card.querySelectorAll('.bp-card-img');
    const dots = card.querySelectorAll('.bp-card-dot');
    let currentIdx = 0;

    function goTo(idx) {
      imgs[currentIdx].classList.remove('active');
      dots[currentIdx]?.classList.remove('active');
      currentIdx = ((idx % imageCount) + imageCount) % imageCount;
      imgs[currentIdx].classList.add('active');
      dots[currentIdx]?.classList.add('active');
    }

    // Estado do arrasto — declarado antes dos handlers de hover que o consultam
    let startX = 0, startY = 0, dragging = false, swiped = false;
    const SWIPE_MIN = 30;

    card.addEventListener('mouseenter', () => { if (currentIdx === 0 && !dragging) goTo(1); });
    card.addEventListener('mouseleave', () => { if (!dragging) goTo(0); });

    // Impede o "arrastar imagem" nativo do navegador, que engolia o gesto no desktop
    imgs.forEach(im => { im.draggable = false; });
    imgContainer.addEventListener('dragstart', (e) => e.preventDefault());

    // Pointer Events cobrem mouse e toque com um handler só
    imgContainer.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      swiped = false;
      startX = e.clientX;
      startY = e.clientY;
    });

    imgContainer.addEventListener('pointermove', (e) => {
      if (!dragging || swiped) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      // Só troca a foto se o gesto for claramente horizontal (deixa o scroll vertical passar)
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) <= Math.abs(dy)) return;
      goTo(dx < 0 ? currentIdx + 1 : currentIdx - 1);
      swiped = true;
    });

    const endDrag = () => { dragging = false; };
    imgContainer.addEventListener('pointerup', endDrag);
    imgContainer.addEventListener('pointercancel', endDrag);
    imgContainer.addEventListener('pointerleave', endDrag);

    // Engole o clique sintético do fim do arrasto para não abrir "Ver Detalhes"
    // nem cair no "Adicionar". Capture: roda antes dos handlers dos botões.
    imgContainer.addEventListener('click', (e) => {
      if (!swiped) return;
      e.preventDefault();
      // stopImmediatePropagation e não stopPropagation: precisa barrar também o
      // listener de abrir detalhes que está no MESMO elemento
      e.stopImmediatePropagation();
      swiped = false;
    }, true);
  }

  // Videos do grid: so carregam e tocam quando entram na tela, e pausam ao sair.
  // Sem isso, 10 videos baixando juntos derrubam o carregamento no celular.
  // Chamar SO depois do appendChild: observar elemento solto no fragment nao dispara.
  function ligarVideos(raiz) {
    const vids = raiz.querySelectorAll('.bp-card-video');
    if (!vids.length) return;
    // muted pela propriedade, e nao so pelo atributo: e o que o navegador olha
    // para liberar o autoplay sem gesto do usuario
    vids.forEach(v => { v.muted = true; v.playsInline = true; });
    const tocar = v => {
      v.preload = 'auto';
      const p = v.play();
      if (p && p.catch) p.catch(() => {
        // ainda sem dados na primeira tentativa: tenta de novo quando houver
        v.addEventListener('canplay', () => v.play().catch(() => {}), { once: true });
      });
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(tocar); return; }
    const obs = new IntersectionObserver((entradas) => {
      entradas.forEach(e => {
        if (e.isIntersecting) tocar(e.target); else e.target.pause();
      });
    }, { rootMargin: '200px', threshold: 0.1 });
    vids.forEach(v => obs.observe(v));

    // O navegador pausa video sem audio quando a aba vai pro fundo, para poupar
    // bateria. Ao voltar, o IntersectionObserver nao dispara de novo (nada se
    // moveu), entao o grid ficaria congelado. Religa o que esta na tela.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) return;
      vids.forEach(v => {
        const r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) tocar(v);
      });
    });
  }

  function createProductCard(product) {
    // só variantes em estoque: a padrão do card e a contagem que decide se
    // o botão adiciona direto ou abre o seletor de opções
    const disponiveis = (product.variants || []).filter(v => v.available);
    const variant = disponiveis[0];
    if (!variant) return null;
    const images = product.images.slice(0, 5).map(img => imgUrl(img?.src || ''));
    const img1 = images[0] || '';
    const { tipo, material } = detectTipoMaterial(product.title);
    const description = (product.body_html || '').replace(/<[^>]+>/g, '').substring(0, 120);

    const card = document.createElement('div');
    card.className = 'bp-product-card';
    card.dataset.variantId = String(variant.id);
    card.dataset.handle = product.handle;
    card.dataset.variantCount = String(disponiveis.length);
    // ids de TODAS as variantes em estoque do produto: é o que permite ao rótulo
    // do botão contar quantas unidades daquele produto já estão no bundle
    card.dataset.variantIds = disponiveis.map(v => v.id).join(',');
    card.dataset.name = product.title;
    card.dataset.image = img1;
    card.dataset.tipo = tipo;
    card.dataset.material = material;
    card.dataset.description = description;

    // Quando a landing manda um video para este handle, ele substitui o carrossel.
    // O video roda mudo, em loop, e so comeca quando entra na tela (ver initCardVideo).
    const videoUrl = CONFIG.videos[product.handle] || '';
    const temVideo = !!videoUrl;

    const imgsHtml = temVideo
      ? `<video class="bp-card-video" muted loop playsinline preload="none"
           poster="${esc(img1)}" src="${esc(videoUrl)}"></video>`
      : images.map((src, i) =>
          `<img class="bp-card-img${i === 0 ? ' active' : ''}" src="${esc(src)}" alt="${esc(product.title)}" loading="lazy">`
        ).join('');
    const dotsHtml = (!temVideo && images.length > 1)
      ? `<div class="bp-card-dots">${images.map((_, i) => `<span class="bp-card-dot${i === 0 ? ' active' : ''}"></span>`).join('')}</div>`
      : '';

    card.innerHTML = `
      <div class="bp-product-card__img">
        ${imgsHtml}
        ${dotsHtml}
        <button class="bp-product-card__quick">Ver Detalhes</button>
      </div>
      <div class="bp-product-card__info">
        <p class="bp-product-card__name"></p>
        ${CONFIG.showPrices ? `<p class="bp-product-card__price">${CONFIG.currency} ${fmtBRL(Number(variant.price))}</p>` : ''}
        <button class="bp-product-card__add">Adicionar</button>
      </div>
    `;
    card.dataset.price = variant.price;
    card.querySelector('.bp-product-card__name').textContent = product.title;
    // o video so e ligado depois que o card entra no DOM (ver ligarVideos):
    // observar um elemento ainda solto no fragment nao dispara o IntersectionObserver
    if (temVideo) card.classList.add('bp-product-card--video');
    if (!temVideo) initCardCarousel(card, images.length);
    initCard(card);
    return card;
  }

  // Ordem de mais vendidos. O endpoint /products.json ignora sort_by, então a
  // ordem vem do template auxiliar templates/collection.bestsellers.liquid,
  // que devolve só os handles já ordenados pela própria Shopify.
  // Se falhar, devolve null e o grid segue na ordem padrão.
  async function fetchBestSellerRank() {
    const url = p => `/collections/all?sort_by=best-selling&view=bestsellers&page=${p}`;
    try {
      const res = await fetch(url(1));
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const first = await res.json();
      let handles = first.handles || [];
      const pages = Math.min(parseInt(first.pages, 10) || 1, 20);
      if (pages > 1) {
        const rest = await Promise.all(
          Array.from({ length: pages - 1 }, (_, i) =>
            fetch(url(i + 2)).then(r => (r.ok ? r.json() : null)).catch(() => null)
          )
        );
        rest.forEach(d => { if (d && d.handles) handles = handles.concat(d.handles); });
      }
      if (!handles.length) return null;
      const rank = new Map();
      handles.forEach((h, i) => { if (!rank.has(h)) rank.set(h, i); });
      return rank;
    } catch (e) {
      console.warn('[Beroc Bundle] ranking de mais vendidos indisponivel:', e);
      return null;
    }
  }

  async function loadProducts() {
    const grid = document.getElementById('bp-picker-grid');
    if (!grid) return;
    try {
      // as duas buscas em paralelo para não somar latência
      const rankPromise = fetchBestSellerRank();
      const res = await fetch('/products.json?limit=250');
      if (!res.ok) throw new Error('API error');
      const data = await res.json();
      // Landing de lista fixa: so os handles pedidos, na ordem escrita.
      if (CONFIG.handles.length) {
        const porHandle = new Map((data.products || []).map(p => [p.handle, p]));
        const escolhidos = CONFIG.handles
          .map(h => porHandle.get(h))
          .filter(p => p && (p.variants || []).some(v => v.available));
        const faltando = CONFIG.handles.filter(h => !porHandle.has(h));
        if (faltando.length) console.warn('[Beroc Bundle] handles nao encontrados:', faltando);
        grid.innerHTML = '';
        const frag = document.createDocumentFragment();
        escolhidos.forEach(p => { const c = createProductCard(p); if (c) frag.appendChild(c); });
        grid.appendChild(frag);
        ligarVideos(grid);
        updateUI();
        return;
      }

      const products = (data.products || []).filter(p => {
        const t = p.title;
        if (!t.includes('Pulseira') && !t.includes('Colar')) return false;
        if (EXCLUDED_KEYWORDS.some(kw => t.includes(kw))) return false;
        if (p.handle === CONFIG.bundleHandle) return false;
        // fora do grid se nenhuma variante estiver em estoque
        if (!(p.variants || []).some(v => v.available)) return false;
        return true;
      });

      // mais vendidos primeiro; quem não aparece no ranking vai para o fim
      const rank = await rankPromise;
      if (rank) {
        const FIM = Number.MAX_SAFE_INTEGER;
        products.sort((a, b) => {
          const ra = rank.has(a.handle) ? rank.get(a.handle) : FIM;
          const rb = rank.has(b.handle) ? rank.get(b.handle) : FIM;
          return ra - rb;
        });
      }

      grid.innerHTML = '';
      const fragment = document.createDocumentFragment();
      products.forEach(p => {
        const card = createProductCard(p);
        if (card) fragment.appendChild(card);
      });
      grid.appendChild(fragment);
      updateUI();
    } catch (e) {
      console.error('[Beroc Bundle] loadProducts error:', e);
      grid.innerHTML = '<p style="text-align:center;color:#888;padding:40px">Erro ao carregar produtos. Recarregue a página.</p>';
    }
  }

  function openQuickView(product, card) {
    const overlay = document.getElementById('bp-modal');
    if (!overlay) return;
    const mainImg = overlay.querySelector('.bp-modal__main-img');
    const title = overlay.querySelector('.bp-modal__title');
    const desc = overlay.querySelector('.bp-modal__desc');
    const addBtn = overlay.querySelector('.bp-modal__add');
    const gallery = overlay.querySelector('.bp-modal__gallery');
    const variantsEl = overlay.querySelector('.bp-modal__variants');

    // product.images é array de strings (URLs com //)
    const firstImg = imgUrl(product.images[0]) || card?.dataset.image || '';
    mainImg.src = firstImg;
    mainImg.alt = product.title;
    title.textContent = product.title;

    desc.innerHTML = product.description;

    // Galeria de thumbs com setas
    if (gallery) {
      gallery.innerHTML = '';
      product.images.slice(0, 10).forEach(imgRaw => {
        const url = imgUrl(imgRaw);
        if (!url) return;
        const thumb = document.createElement('img');
        thumb.src = url;
        thumb.alt = product.title;
        thumb.addEventListener('click', () => {
          mainImg.src = url;
          gallery.querySelectorAll('img').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        });
        if (url === firstImg) thumb.classList.add('active');
        gallery.appendChild(thumb);
      });
      const prevBtn = overlay.querySelector('.bp-modal__gallery-prev');
      const nextBtn = overlay.querySelector('.bp-modal__gallery-next');
      if (prevBtn) prevBtn.onclick = () => gallery.scrollBy({ left: -130, behavior: 'smooth' });
      if (nextBtn) nextBtn.onclick = () => gallery.scrollBy({ left: 130, behavior: 'smooth' });
    }

    // no modal também só aparecem variantes em estoque
    const variantesOk = (product.variants || []).filter(v => v.available);
    const base = variantesOk[0] || product.variants[0];
    let selectedVariantId = String(base.id);
    let selectedVariantImage = imgUrl(base.featured_image?.src) || firstImg;
    let selectedVariantTitle = base.title;

    if (variantsEl) {
      variantsEl.innerHTML = '';
      if (variantesOk.length > 1) {
        const labelEl = document.createElement('p');
        labelEl.className = 'bp-modal__variant-label';
        labelEl.textContent = product.options[0]?.name || 'Opção';
        variantsEl.appendChild(labelEl);
        const optionsWrap = document.createElement('div');
        optionsWrap.className = 'bp-modal__variant-options';
        variantesOk.forEach(v => {
          const btn = document.createElement('button');
          btn.className = 'bp-modal__variant-btn';
          btn.textContent = v.title;
          if (String(v.id) === selectedVariantId) btn.classList.add('active');
          btn.addEventListener('click', () => {
            selectedVariantId = String(v.id);
            selectedVariantImage = imgUrl(v.featured_image?.src) || firstImg;
            selectedVariantTitle = v.title;
            if (v.featured_image?.src) mainImg.src = imgUrl(v.featured_image.src);
            optionsWrap.querySelectorAll('.bp-modal__variant-btn').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            updateAddBtn();
          });
          optionsWrap.appendChild(btn);
        });
        variantsEl.appendChild(optionsWrap);
      }
    }

    const updateAddBtn = () => {
      const n = countOf(selectedVariantId);
      addBtn.textContent = n > 0 ? `Adicionar mais (${n} no bundle)` : 'Adicionar ao Bundle';
    };
    updateAddBtn();

    addBtn.onclick = () => {
      if (selected.length >= CONFIG.qty) { shakeBar(); return; }
      addItem({
        variantId: selectedVariantId,
        name: variantesOk.length > 1 ? `${product.title} — ${selectedVariantTitle}` : product.title,
        image: selectedVariantImage,
        tipo: card?.dataset.tipo || '',
        material: card?.dataset.material || '',
        price: (variantesOk.find(v => String(v.id) === selectedVariantId) || base).price,
      });
      updateAddBtn();
    };

    overlay.classList.add('open');
  }

  function openQuickViewBasic(item) {
    const overlay = document.getElementById('bp-modal');
    if (!overlay) return;
    overlay.querySelector('.bp-modal__main-img').src = item.image;
    overlay.querySelector('.bp-modal__main-img').alt = item.name;
    overlay.querySelector('.bp-modal__title').textContent = item.name;
    overlay.querySelector('.bp-modal__desc').textContent = item.description;
    const variantsEl = overlay.querySelector('.bp-modal__variants');
    if (variantsEl) variantsEl.innerHTML = '';
    const gallery = overlay.querySelector('.bp-modal__gallery');
    if (gallery) gallery.innerHTML = '';
    const addBtn = overlay.querySelector('.bp-modal__add');
    const syncBtn = () => {
      const n = countOf(item.variantId);
      addBtn.textContent = n > 0 ? `Adicionar mais (${n} no bundle)` : 'Adicionar ao Bundle';
    };
    syncBtn();
    addBtn.onclick = () => {
      if (selected.length >= CONFIG.qty) { shakeBar(); return; }
      addItem({ ...item });
      syncBtn();
    };
    overlay.classList.add('open');
  }

  function initModal() {
    const overlay = document.getElementById('bp-modal');
    if (!overlay) return;
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) overlay.classList.remove('open');
    });
    overlay.querySelector('.bp-modal__close')?.addEventListener('click', () => {
      overlay.classList.remove('open');
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') overlay.classList.remove('open');
    });

    // Swipe de imagem no mobile
    const mainImg = overlay.querySelector('.bp-modal__main-img');
    if (mainImg) {
      let touchStartX = 0;
      mainImg.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      mainImg.addEventListener('touchend', (e) => {
        const delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) < 40) return;
        const gallery = overlay.querySelector('.bp-modal__gallery');
        const thumbs = gallery ? Array.from(gallery.querySelectorAll('img')) : [];
        if (thumbs.length <= 1) return;
        const activeIdx = thumbs.findIndex(t => t.classList.contains('active'));
        const nextIdx = delta < 0
          ? (activeIdx + 1) % thumbs.length
          : (activeIdx - 1 + thumbs.length) % thumbs.length;
        const next = thumbs[nextIdx];
        mainImg.src = next.src;
        thumbs.forEach(t => t.classList.remove('active'));
        next.classList.add('active');
        next.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }, { passive: true });
    }
  }

  // Abre a gaveta do carrinho do tema (Prestige). Usada pelo "+N" das
  // miniaturas e pelo botao de finalizar.
  function abrirGaveta() {
    const gaveta = document.getElementById('cart-drawer');
    // No Prestige a gaveta e um <cart-drawer> e o metodo e show(); open() NAO existe
    // (ate 30/09 caia sempre no clique do atalho, que e mais fragil).
    if (gaveta) {
      if (typeof gaveta.show === 'function') { gaveta.show(); return; }
      if (typeof gaveta.open === 'function') { gaveta.open(); return; }
    }
    const atalho = document.querySelector('[aria-controls="cart-drawer"]');
    if (atalho) { atalho.click(); return; }
    window.location.href = '/cart';
  }

  // ✕ na miniatura: tira uma unidade daquela linha sem sair da landing.
  // Delegado no container porque as miniaturas sao redesenhadas a cada leitura.
  function initRemoverMini() {
    const minis = document.querySelector('.bp-of__miniaturas');
    if (!minis) return;
    minis.addEventListener('click', async (e) => {
      // "+N": manda para a gaveta do carrinho, onde ele ve e tira qualquer item
      if (e.target.closest('[data-abrir-carrinho]')) {
        e.preventDefault();
        abrirGaveta();
        return;
      }
      const btn = e.target.closest('.bp-of__mini-x');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const linha = parseInt(btn.dataset.linha, 10);
      const qtd = parseInt(btn.dataset.qtd, 10);
      if (!linha || !qtd) return;
      btn.disabled = true;
      await mudarLinhaCarrinho(linha, Math.max(0, qtd - 1));
      // tirou a ultima pulseira: a protecao sozinha no carrinho nao faz sentido
      if (totalPulseiras(carrinho) === 0) {
        const lp = linhaProtecao(carrinho);
        if (lp) await mudarLinhaCarrinho(lp, 0);
      }
    });
  }

  function initCheckout() {
    const btn = document.querySelector('.bp-checkout-btn');
    if (!btn) return;
    btn.addEventListener('click', async () => {
      // modo ofertas: os itens ja estao no carrinho da loja, so segue pro caixa
      if (CONFIG.modo === 'ofertas') {
        if (!carrinho || carrinho.item_count === 0) return;
        btn.textContent = 'Aguarde...';
        btn.disabled = true;
        window.location.href = '/checkout';
        return;
      }
      const kitCompleto = selected.length === CONFIG.qty;
      // sem o recurso ligado, segue a regra antiga: só fecha com o kit inteiro
      if (!kitCompleto && !CONFIG.allowPartial) return;
      if (!selected.length) return;
      if (kitCompleto && !CONFIG.bundleVariantId) { console.error('[Beroc Bundle] bundleVariantId não configurado'); return; }
      btn.textContent = 'Aguarde...';
      btn.disabled = true;
      try {
        await fetch('/cart/clear.js', { method: 'POST' });

        let items;
        if (kitCompleto) {
          // caminho do kit: um item só, preço fechado, pulseiras como propriedades
          const properties = {};
          selected.forEach((item, i) => { properties[`Pulseira ${i + 1}`] = item.name; });
          // chave com "_" fica oculta para o cliente mas grava no pedido:
          // é o que permite saber qual landing gerou cada venda
          if (CONFIG.landingId) properties._landing = CONFIG.landingId;
          items = [{ id: parseInt(CONFIG.bundleVariantId), quantity: 1, properties }];
        } else {
          // caminho avulso: as pulseiras de verdade, preço cheio.
          // repetidas viram quantidade, senão a Shopify recusa ids duplicados.
          const porVariante = new Map();
          selected.forEach(it => porVariante.set(it.variantId, (porVariante.get(it.variantId) || 0) + 1));
          items = [...porVariante].map(([id, qty]) => {
            const linha = { id: parseInt(id, 10), quantity: qty };
            if (CONFIG.landingId) linha.properties = { _landing: CONFIG.landingId };
            return linha;
          });
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Erro'); }
        window.location.href = '/checkout';
      } catch (err) {
        console.error('[Beroc Bundle] Checkout error:', err);
        btn.textContent = 'ERRO — TENTE NOVAMENTE';
        btn.classList.add('ready');
        btn.disabled = false;
      }
    });
  }

  function shakeBar() {
    const bar = document.querySelector('.bp-sticky-bar');
    bar?.classList.add('shake');
    setTimeout(() => bar?.classList.remove('shake'), 400);
  }

  function initSocialVideos() {
    document.querySelectorAll('.bp-sv__card').forEach(card => {
      const video = card.querySelector('video');
      const playBtn = card.querySelector('.bp-sv__play');
      if (!video || !playBtn) return;
      function togglePlay() {
        if (video.paused) {
          document.querySelectorAll('.bp-sv__card video').forEach(v => { if (v !== video) { v.pause(); v.closest('.bp-sv__card').classList.remove('playing'); } });
          video.play();
          card.classList.add('playing');
        } else {
          video.pause();
          card.classList.remove('playing');
        }
      }
      playBtn.addEventListener('click', (e) => { e.stopPropagation(); togglePlay(); });
      video.addEventListener('click', togglePlay);
      video.addEventListener('ended', () => card.classList.remove('playing'));
    });
  }

  function initScrollCTAs() {
    document.querySelectorAll('a[href="#bundle-picker"]').forEach(a => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementById('bundle-picker')?.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  const style = document.createElement('style');
  style.textContent = `
    @keyframes bp-shake {
      0%, 100% { transform: translateX(0); }
      20% { transform: translateX(-6px); }
      40% { transform: translateX(6px); }
      60% { transform: translateX(-4px); }
      80% { transform: translateX(4px); }
    }
    .shake { animation: bp-shake 0.4s ease; }
    .bp-variant-picker {
      position: absolute; bottom: 0; left: 0; right: 0;
      background: #fff; border: 2px solid #111111; border-radius: 8px;
      padding: 12px; z-index: 10; box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    }
    .bp-variant-picker__label { font-size: 12px; font-weight: 600; color: #444; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.06em; }
    .bp-variant-picker__options { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }
    .bp-variant-option { padding: 6px 12px; border: 2px solid #E8E0D0; border-radius: 20px; background: #fff; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; }
    .bp-variant-option:hover { border-color: #111111; background: #111111; color: #fff; }
    .bp-variant-picker__close { position: absolute; top: 8px; right: 8px; background: none; border: none; font-size: 14px; cursor: pointer; color: #888; padding: 2px 6px; }
    .bp-product-card { position: relative; }
    /* gallery styles agora no bundle-picker.css */
    .bp-modal__variant-label { font-size: 12px; font-weight: 600; color: #666; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 8px; }
    .bp-modal__variant-options { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 16px; }
    .bp-modal__variant-btn { padding: 7px 16px; border: 2px solid #E8E0D0; border-radius: 20px; background: #fff; font-size: 13px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; }
    .bp-modal__variant-btn.active, .bp-modal__variant-btn:hover { border-color: #111111; background: #111111; color: #fff; }
    .bp-modal__variants { margin-bottom: 16px; }
  `;
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', () => {
    initCountdown();
    loadProducts();
    initFilters();
    initModal();
    initCheckout();
    initRemoverMini();
    initSocialVideos();
    initScrollCTAs();
    // no modo ofertas o estado inicial vem do carrinho que a pessoa ja tenha
    if (CONFIG.modo === 'ofertas') lerCarrinho(); else updateUI();
    syncBarSpacing();
    window.addEventListener('load', syncBarSpacing);
    window.addEventListener('orientationchange', syncBarSpacing);
    // Os dois mecanismos juntos, de propósito: o resize cobre troca de
    // breakpoint e rotação; o ResizeObserver cobre mudança de altura da barra
    // sem resize (quebra de linha do botão). Chamar duas vezes é inofensivo.
    window.addEventListener('resize', syncBarSpacing);
    // o numero de fotos visiveis muda entre celular e desktop: redesenha a
    // barra quando a largura cruza o breakpoint (rotacao de tela, por exemplo)
    if (CONFIG.modo === 'ofertas') {
      let larguraAnterior = window.innerWidth;
      window.addEventListener('resize', () => {
        const cruzou = (larguraAnterior <= 900) !== (window.innerWidth <= 900);
        larguraAnterior = window.innerWidth;
        if (cruzou) renderBarraOfertas();
      });
    }
    const barEl = document.querySelector('.bp-sticky-bar');
    if (barEl && window.ResizeObserver) {
      new ResizeObserver(syncBarSpacing).observe(barEl);
    }
  });

})();
// build: 1790443695
